<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <b-card class="w-100">
          <b-tabs>
            <b-tab id="tab-left-1" title="รายละเอียดเรื่องแจ้งเบาะแส">
              <ClueDetail 
                :clueData="clueData"
              />
            </b-tab>
            <TabAttachFiles
              @handle-upload="onAttachFileUploaded"
              @handle-delete="onAttachFileDelete"
              :attachFiles="clueData.attachFiles"
              :attachFileDate="clueData.attachFileDates"
              :IsEdit_TabAttachFiles="false"
            />
          </b-tabs>
        </b-card>
      </b-row>
    </b-col>
    <RightTab
      :clueId="this.$route.query.id"
      :clueAction="this.$route.query.clueAction"
      :isClue="true"
      :redirectComponentName="'RequestConfirm'"
      :backComponentName="'ClueSearch'"
      :copyComponentName="'ClueSearchManage'"
      :IsUse_Tab3="false"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import ClueDetail from "../components/ClueDetail";

import RightTab from "../../components/RightTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";

import * as clueStore from "@/store/api/clue/index.js";
import * as userStore from "@/store/api/user/index.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    RightTab,
    TabAttachFiles,

    ClueDetail,
  },
  data() {
    return {
      clueData: {
        attachFiles: [],
        attachFileDates: [],
      },
    };
  },
  mounted() {
    this.getClueData();
  },
  methods: {
    getClueData() {
      const _this = this;
      clueStore
        .getById(this.$route.query.id)
        .then((response) => {
          _this.clueData = response.data.data;
          console.log("getClueData - ClueSearch", response.data.data);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onAttachFileUploaded(file) {
      console.log("onAttachFileUploaded", file);
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      console.log("onAttachFileDelete", id, file);
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
  },
};
</script>

<style lang="scss"></style>
